import React, { useEffect, useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col, Modal, Form, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from '../Components/Message/errorMessage';
import SuccessMessage from '../Components/Message/successMessage';
import TableLoader from '../Components/Loader/TableLoader';
import {
  Button as MaterialButton,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
} from '@material-ui/core/';
import { shippingListForAdmin, deleteShipping, createShipping } from '../Actions/shippingAction';
import * as routes from '../Constants/routes';
import { interpolate } from '../utils/string';
import * as shippingConstants from '../Constants/shippingConstants';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 330,
    top: 6,
    left: -4,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  prgressColor: {
    color: '#000000',
  },
}));

const ShippingList = () => {
  const dispatch = useDispatch();

  const shippingList = useSelector((state) => state.shippingList);
  const { loading, shippings, count, error, success } = shippingList;

  const deleteShippingData = useSelector((state) => state.deleteShipping);
  const { success: deleteSuccess, error: deleteFail } = deleteShippingData;

  const createShippingDetails = useSelector((state) => state.createShippingDetails);
  const { success: createSuccess, error: createFail, loading: createLoading } = createShippingDetails;

  const classes = useStyles();

  const [area, setArea] = useState('');
  const [shippingPrice, setShippingPrice] = useState('');
  const [openForm, setOpenForm] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (createSuccess) {
      setOpenForm(false);
      setArea('');
      setShippingPrice('');

      dispatch({ type: shippingConstants.CREATE_SHIPPING_RESET });
    }

    dispatch(shippingListForAdmin(initialLoading));

    // eslint-disable-next-line
  }, [dispatch, deleteSuccess, createSuccess]);

  useEffect(() => {
    if (success && initialLoading) {
      setInitialLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch, success]);

  const cancelCreateShipping = () => {
    setOpenForm(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      area === '' ||
      shippingPrice === ''
      
    ) {
      return;
    }

    const formData = new FormData();

    formData.append('area', area);
    formData.append('shippingPrice', shippingPrice);
    dispatch(createShipping(formData));
  };

  const openNewShippingForm = () => {
    if (openForm) {
      return (
        <>
          <Modal show={openForm} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">Add Shipping Address</Modal.Title>
            </Modal.Header>
            {createFail && (
              <ErrorMessage
                header="Something went wrong"
                message={createFail}
                reset={shippingConstants.CREATE_SHIPPING_RESET}
              />
            )}
            <Form onSubmit={submitHandler}>
              <Modal.Body className="show-grid">
                <Container>
                  <Row>
                    <Col xs={12} md={6}>
                      <TextField
                        variant="outlined"
                        type="number"
                        margin="normal"
                        required
                        fullWidth
                        id="shippingPrice"
                        label="Price"
                        name="shippingPrice"
                        autoComplete="price"
                        autoFocus
                        value={shippingPrice}
                        onChange={(e) => setShippingPrice(Number(e.target.value))}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={6}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          onChange={(e) => setArea(e.target.value)}
                          label="Area"
                          value={area}
                        >
                          <MenuItem value="Kawangware">Kawangware</MenuItem>
                          <MenuItem value="Congo">Congo</MenuItem>
                          <MenuItem value="Amboseli">Amboseli</MenuItem>
                          <MenuItem value="Lavington">Lavington</MenuItem>
                          <MenuItem value="Yaya">Yaya</MenuItem>
                          <MenuItem value="Hurlingham">Hurlingham</MenuItem>
                          <MenuItem value="Kitengela">Kitengela</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                  </Row>
                </Container>
              </Modal.Body>
              <Modal.Footer>
                <MaterialButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="mr-2"
                  disabled={createLoading}
                >
                  {createLoading ? <CircularProgress color="inherit" className={classes.prgressColor} /> : <>Submit</>}
                </MaterialButton>{' '}
                <MaterialButton variant="contained" color="primary" onClick={cancelCreateShipping}>
                  Close
                </MaterialButton>
              </Modal.Footer>
            </Form>
          </Modal>
        </>
      );
    }
  };

  const deleteHandler = (id, e) => {
    e.preventDefault();
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1 className="font-weight-bold text-white">Are you sure?</h1>
            <p>You want to delete this shipping area?</p>
            <MaterialButton
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(deleteShipping(id));
                onClose();
              }}
            >
              Yes, Delete it !
            </MaterialButton>
            <MaterialButton variant="contained" color="primary" onClick={onClose}>
              No
            </MaterialButton>
          </div>
        );
      },
    });
  };

  return (
    <>
      {deleteSuccess && (
        <SuccessMessage
          header="Done"
          message="Area Deleted Successfully"
          reset={shippingConstants.DELETE_SHIPPING_RESET}
        />
      )}
      {deleteFail && (
        <ErrorMessage
          header="Something went wrong"
          message={deleteFail}
          reset={shippingConstants.DELETE_SHIPPING_RESET}
        />
      )}
      <Row>
        <Col>
          <h1>Areas({count})</h1>
        </Col>
        <Col className="text-right">
          <MaterialButton variant="contained" color="primary" onClick={() => setOpenForm(true)}>
            <i className="fas fa-plus mr-2"></i> Add An Area
          </MaterialButton>
        </Col>
      </Row>
      {loading ? (
        <TableLoader />
      ) : error ? (
        <ErrorMessage header="Something went wrong" message={error} />
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>AREA</th>
                <th>PRICE</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {shippings.map((shipping) => (
                <tr key={shipping._id}>
                  <td>{shipping._id}</td>
                  <td>{shipping.area}</td>
                  <td>Ksh{shipping.shippingPrice}</td>
                  <td>
                    <LinkContainer
                      to={interpolate(routes.SHIPPING_EDIT, {
                        shippingId: shipping._id,
                      })}
                    >
                      <Button variant="light" className="btn-sm">
                        <i className="fas fa-edit"></i>
                      </Button>
                    </LinkContainer>
                    <Button variant="danger" className="btn-sm" onClick={(e) => deleteHandler(shipping._id, e)}>
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
      {openNewShippingForm()}
    </>
  );
};

export default ShippingList;
